import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isPolaris } from '../utils/auth';
import { unauthorizedLoginPath } from '../utils/loginRedirect';

export default function RequirePolaris() {
    const location = useLocation();
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to={unauthorizedLoginPath(location)} replace />;
    }

    if (!isPolaris()) {
        return <Navigate to="/login?error=unauthorized" replace />;
    }

    return <Outlet />;
}
